import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { RESET_SPECIFIC_CATEGORIES } from "../../store/Types/CategoryTypes";
import { useTranslation } from "react-i18next";
import { Dropdown } from "primereact/dropdown";
import { Country, State, City } from "country-state-city";
import * as Yup from "yup";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Icons, toast } from "react-toastify";
import { Divider } from "primereact/divider";
import { TabMenu } from "primereact/tabmenu";

import {
  addCurrency,
  getEnableCurrency,
  getspecificCurrency,
  updateCurrency,
} from "../../store/AsyncMethods/CurrencyMethod";
import { SelectButton } from "primereact/selectbutton";
import {
  addCustomers,
  getCustomers,
  getspecificCustomer,
  updateCustomer,
} from "../../store/AsyncMethods/CustomerMethod";
import MultiLanguageNames from "../../components/OtherComponents/MultiLanguageNames";
import CustomerBalance from "./CustomerBalance";
import CustomerSetup from "./CustomerSetup";

export default function AddCustomers() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const countries = Country.getAllCountries();
  const [allStates, setStates] = useState([]);
  const [allCities, setCities] = useState([]);
  const navigate = useNavigate();
  const { customerId } = useParams();
  const { specificCustomer } = useSelector((state) => state.CustomersReducer);
  const [activeIndex, setActiveIndex] = useState(0);

  const [showMultiLangModal, setShowMultiLangModal] = useState(false);
  const statusOptions = [
    { name: t("active"), value: true },
    { name: t("deactive"), value: false },
  ];
  const items = [
    { label: "Add Customer", icon: "pi pi-wrench" },
    { label: "Add Customer Balance", icon: "pi pi-users" },
    { label: "Customer Setup", icon: "pi pi-pencil" },
  ];
  useEffect(() => {
    //console.log("specific", specificCustomer);
    if (specificCustomer) {
      formik.setValues({
        id: specificCustomer.id || "",
        name: specificCustomer.name || "",
        multiNames: specificCustomer.customerLanguages || [],
        creditAmount: specificCustomer.credit_amount || "",
        debitAmount: specificCustomer.debit_amount || "",
        openingDate: specificCustomer.opening_date || "",
        poNumber: specificCustomer.custpo || "",
        email: specificCustomer.email || "",
        vatNumber: specificCustomer.vat_number || "",
        phone: specificCustomer.phone || "",
        phone2: specificCustomer.phone2 || "",
        telephone: specificCustomer.telephone || "",
        fax: specificCustomer.fax || "",
        address1: specificCustomer.address1 || "",
        address2: specificCustomer.address2 || "",
        shippingAddress1: specificCustomer.shipping_address1 || "",
        shippingAddress2: specificCustomer.shipping_address2 || "",
        billingAddress1: specificCustomer.billing_address1 || "",
        billingAddress2: specificCustomer.billing_address2 || "",
        country: specificCustomer.country || "",
        state: specificCustomer.state || "",
        city: specificCustomer.city || "",
        latitude: specificCustomer.latitude || "",
        longitude: specificCustomer.longitude || "",
        status: specificCustomer.is_active === 1 ? true : false,
        paymentType: specificCustomer.debit_allowed === 1 ? "debit" : "credit",
        shipping_building: specificCustomer.shipping_building || "",
        shipping_building_ar: specificCustomer.shipping_building_ar || "",
        shipping_postalcode: specificCustomer.shipping_postalcode || "",
        shipping_postalcode_ar: specificCustomer.shipping_postalcode_ar || "",
        shipping_country: specificCustomer.shipping_country || "",
        shipping_country_ar: specificCustomer.shipping_country_ar || "",
        billing_building: specificCustomer.billing_building || "",
        billing_building_ar: specificCustomer.billing_building_ar || "",
        billing_postalcode: specificCustomer.billing_postalcode || "",
        billing_postalcode_ar: specificCustomer.billing_postalcode_ar || "",
        billing_country: specificCustomer.billing_country || "",
        billing_country_ar: specificCustomer.billing_country_ar || "",
      });
    }
  }, [specificCustomer]);

  const formik = useFormik({
    initialValues: {
      name: "",
      multiNames: [],
      email: "",
      poNumber: "",
      phone: "",
      phone2: "",
      address1: "",
      address2: "",
      shippingAddress1: "",
      shippingAddress2: "",
      billingAddress1: "",
      billingAddress2: "",
      vatNumber: "",
      country: "PK",
      state: "PB",
      city: "Gujrat",
      latitude: "",
      longitude: "",
      telephone: "",
      fax: "",
      status: true,
      paymentType: "credit",
      shipping_building: "",
      shipping_building_ar: "",
      shipping_postalcode: "",
      shipping_postalcode_ar: "",
      shipping_country: "",
      shipping_country_ar: "",
      billing_building: "",
      billing_building_ar: "",
      billing_postalcode: "",
      billing_postalcode_ar: "",
      billing_country: "",
      billing_country_ar: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name Required"),
      //   email: Yup.string().required("Email Required"),
      phone: Yup.string().required("Phone Required"),
      // poNumber: Yup.string().required("Customer PO required"),
      address1: Yup.string().required("Address Required"),
      // vatNumber: Yup.string()
      //   .required("VAT Number Required")
      //   .matches(
      //     /^3\d{13}3$/,
      //     'VAT Number must be 15 digits long and start and end with "3"'
      //   ),
      // shippingAddress1: Yup.string().required("Shipping Address Required"),
      // billingAddress1: Yup.string().required("Billing Address Required"),
      country: Yup.string().required("Country Required"),
      state: Yup.string().required("State Required"),
      city: Yup.string().required("City Required"),
      // status: Yup.boolean().required("Status Required"),
      // shipping_building: Yup.string().required("Shipping Building is required"),
      // shipping_building_ar: Yup.string().required(
      //   "Shipping Building (AR) is required"
      // ),
      // shipping_postalcode: Yup.string().required(
      //   "Shipping Postal Code is required"
      // ),
      // shipping_postalcode_ar: Yup.string().required(
      //   "Shipping Postal Code (AR) is required"
      // ),
      // shipping_country: Yup.string().required("Shipping Country is required"),
      // shipping_country_ar: Yup.string().required(
      //   "Shipping Country (AR) is required"
      // ),
      // billing_building: Yup.string().required("Billing Building is required"),
      // billing_building_ar: Yup.string().required(
      //   "Billing Building (AR) is required"
      // ),
      // billing_postalcode: Yup.string().required(
      //   "Billing Postal Code is required"
      // ),
      // billing_postalcode_ar: Yup.string().required(
      //   "Billing Postal Code (AR) is required"
      // ),
      // billing_country: Yup.string().required("Billing Country is required"),
      // billing_country_ar: Yup.string().required(
      //   "Billing Country (AR) is required"
      // ),
    }),

    onSubmit: async (data) => {
      if (customerId) {
        dispatch(updateCustomer(data, customerId)).then((success) => {
          if (success) {
            formik.resetForm();
            dispatch(getCustomers());
            navigate("/manage-customers");
          }
        });
      } else {
        dispatch(addCustomers(data)).then((success) => {
          if (success) {
            formik.resetForm();
            dispatch(getCustomers());
            navigate("/manage-customers");
          }
        });
      }
    },
  });

  useEffect(() => {
    if (customerId) {
      dispatch(getspecificCustomer(customerId));
    }
  }, []);

  useEffect(() => {
    setStates(State.getStatesOfCountry(formik.values.country));
  }, [formik.values.country]);
  useEffect(() => {
    setCities(
      City.getCitiesOfState(formik.values.country, formik.values.state)
    );
  }, [formik.values.state]);
  return (
    <div className="mx-4">
      {/* <div>
        <Button
          label="Back"
          icon="pi pi-arrow-left"
          className="p-black-btn"
          onClick={() => navigate(-1)}
        />
      </div> */}
      <form onSubmit={formik.handleSubmit}>
        <TabMenu
          model={items}
          key={activeIndex}
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
          pt={{
            root: { className: "!overflow-hidden" },
            menu: {
              className: "!bg-transparent !inline-flex mb-4 ",
            },
            action: { className: "!bg-transparent" },
            label: { className: "!text-primary" },
            icon: { className: "!text-primary" },
          }}
        />
        {activeIndex === 0 && (
          <div>
            <div className="card shadow-md rounded-lg p-4 mt-3">
              <Divider>
                <span className="text-2xl font-bold p-font-style text-center text-primary mx-1">
                  {customerId ? t("edit") : t("add")} {t("customers")}
                </span>
              </Divider>

              <div className="px-4 gap-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                <div className="">
                  <div className="flex flex-col gap-2">
                    <label htmlFor="name" className="">
                      {t("name")}*
                    </label>
                    <span className=" flex gap-2 w-full">
                      <InputText
                        id="name"
                        name="name"
                        className="w-full text-lg p-primary-input"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                      />

                      <Button
                        type="button"
                        icon="fi fi-gb"
                        size="large"
                        text
                        rounded
                        className="  scale-100 !mr-auto"
                        onClick={() => {
                          setShowMultiLangModal(true);
                        }}
                      />
                    </span>
                  </div>

                  {formik.touched?.name && formik.errors?.name && (
                    <div className="p-error">{formik.errors?.name}</div>
                  )}
                </div>

                <div className="">
                  <div className="flex flex-col gap-2">
                    <label htmlFor="email" className="">
                      {t("email")}
                    </label>
                    <span className=" w-full">
                      <InputText
                        id="email"
                        name="email"
                        className="w-full text-lg p-primary-input"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                      />
                    </span>
                  </div>
                  {formik.touched?.email && formik.errors?.email && (
                    <div className="p-error">{formik.errors?.email}</div>
                  )}
                </div>
                <div className=" flex gap-2">
                  {/* <div className="flex flex-col gap-2">
                    <label htmlFor="vatNumber" className="">
                      {t("vat_number")}
                    </label>
                    <span className=" w-full">
                      <InputText
                        id="vatNumber"
                        name="vatNumber"
                        type="number"
                        className="w-full text-lg p-primary-input"
                        value={formik.values.vatNumber}
                        onChange={formik.handleChange}
                      />
                    </span>
                  </div> */}
                  {/* {formik.touched?.vatNumber && formik.errors?.vatNumber && (
                <div className="p-error">{formik.errors?.vatNumber}</div>
              )} */}
                  {/* <div className="flex flex-col gap-2">
                    <label htmlFor="poNumber" className="">
                      {t("po_number")}
                    </label>
                    <span className=" w-full">
                      <InputText
                        id="poNumber"
                        name="poNumber"
                        className="w-full text-lg p-primary-input"
                        value={formik.values.poNumber}
                        onChange={formik.handleChange}
                      />
                    </span>
                  </div> */}
                </div>

                <div className="">
                  <div className="flex flex-col gap-2">
                    <label htmlFor="status" className="">
                      {t("status")}*
                    </label>
                    <SelectButton
                      name="status"
                      id="status"
                      options={statusOptions}
                      optionLabel="name"
                      optionValue="value"
                      className="flex"
                      pt={{
                        root: { className: "flex" },
                        button: ({ context }) => ({
                          className: context.selected
                            ? "p-primary-highlight-btn w-full text-lg text-center"
                            : "w-full text-lg text-center",
                        }),
                      }}
                      value={formik.values.status}
                      onChange={formik.handleChange}
                    />
                    {formik.touched.status && formik.errors.status && (
                      <div className="p-error">{formik.errors.status}</div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
              <div className="card shadow-md rounded-lg p-4 pt-1 mt-3">
                <Divider>
                  <span className="text-2xl font-bold p-font-style text-center text-primary mx-1">
                    {t("country_detail")}
                  </span>
                </Divider>

                <div className="px-4 gap-4 grid grid-cols-1 lg:grid-cols-2">
                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label htmlFor="country" className="">
                        Select Country
                      </label>
                      <Dropdown
                        placeholder="Select"
                        id="country"
                        name="country"
                        className="!w-full text-lg p-primary-input"
                        value={formik.values.country}
                        onChange={formik.handleChange}
                        options={countries}
                        optionLabel="name"
                        optionValue="isoCode"
                        filter
                        pt={{
                          root: { className: "w-full" },
                          input: { className: "w-full p-primary-input" },
                          filterIcon: { className: "ml-1" },
                          filterInput: { className: "pl-6" },
                        }}
                      />
                    </div>
                    {formik.touched?.country && formik.errors?.country && (
                      <div className="p-error">{formik.errors?.country}</div>
                    )}
                  </div>

                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label htmlFor="state" className="">
                        Select State
                      </label>
                      <Dropdown
                        placeholder="Select"
                        id="state"
                        name="state"
                        className="!w-full text-lg p-primary-input"
                        value={formik.values.state}
                        onChange={formik.handleChange}
                        options={allStates}
                        optionLabel="name"
                        optionValue="isoCode"
                        filter
                        pt={{
                          root: { className: "w-full" },
                          input: { className: "w-full p-primary-input" },
                          filterIcon: { className: "ml-1" },
                          filterInput: { className: "pl-6" },
                        }}
                      />
                    </div>
                    {formik.touched?.state && formik.errors?.state && (
                      <div className="p-error">{formik.errors?.state}</div>
                    )}
                  </div>

                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label htmlFor="city" className="">
                        Select City
                      </label>
                      <Dropdown
                        placeholder="Select"
                        id="city"
                        name="city"
                        className="!w-full text-lg p-primary-input"
                        value={formik.values.city}
                        onChange={formik.handleChange}
                        options={allCities}
                        optionLabel="name"
                        optionValue="name"
                        filter
                        pt={{
                          root: { className: "w-full" },
                          input: { className: "w-full p-primary-input" },
                          filterIcon: { className: "ml-1" },
                          filterInput: { className: "pl-6" },
                        }}
                      />
                    </div>
                    {formik.touched?.city && formik.errors?.city && (
                      <div className="p-error">{formik.errors?.city}</div>
                    )}
                  </div>
                </div>

                <Divider>
                  <span className="text-2xl font-bold p-font-style text-center text-primary mx-1">
                    {t("phone_line_detail")}
                  </span>
                </Divider>

                <div className="px-4 gap-4 grid grid-cols-1 lg:grid-cols-2">
                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label htmlFor="phone" className="">
                        {t("phone_line_1")}*
                      </label>
                      <span className=" w-full">
                        <InputText
                          id="phone"
                          name="phone"
                          className="w-full text-lg p-primary-input"
                          value={formik.values.phone}
                          onChange={formik.handleChange}
                        />
                      </span>
                    </div>
                    {formik.touched?.phone && formik.errors?.phone && (
                      <div className="p-error">{formik.errors?.phone}</div>
                    )}
                  </div>

                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label htmlFor="phone2" className="">
                        {t("phone_line_2")}
                      </label>
                      <span className=" w-full">
                        <InputText
                          id="phone2"
                          name="phone2"
                          className="w-full text-lg p-primary-input"
                          value={formik.values.phone2}
                          onChange={formik.handleChange}
                        />
                      </span>
                    </div>
                    {formik.touched?.phone2 && formik.errors?.phone2 && (
                      <div className="p-error">{formik.errors?.phone2}</div>
                    )}
                  </div>

                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label htmlFor="telephone" className="">
                        {t("telephone")}
                      </label>
                      <span className=" w-full">
                        <InputText
                          id="telephone"
                          name="telephone"
                          className="w-full text-lg p-primary-input"
                          value={formik.values.telephone}
                          onChange={formik.handleChange}
                        />
                      </span>
                    </div>
                    {formik.touched?.telephone && formik.errors?.telephone && (
                      <div className="p-error">{formik.errors?.telephone}</div>
                    )}
                  </div>

                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label htmlFor="fax" className="">
                        {t("fax_number")}
                      </label>
                      <span className=" w-full">
                        <InputText
                          id="fax"
                          name="fax"
                          className="w-full text-lg p-primary-input"
                          value={formik.values.fax}
                          onChange={formik.handleChange}
                        />
                      </span>
                    </div>
                    {formik.touched?.fax && formik.errors?.fax && (
                      <div className="p-error">{formik.errors?.fax}</div>
                    )}
                  </div>
                </div>
              </div>
              <div className="card shadow-md rounded-lg p-4 pt-1 mt-3">
                <Divider>
                  <span className="text-2xl font-bold p-font-style text-center text-primary mx-1">
                    {t("address_detail")}
                  </span>
                </Divider>

                <div className="px-4 gap-4 grid grid-cols-1 lg:grid-cols-2">
                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label htmlFor="latitude" className="">
                        {t("Company Name")}
                      </label>
                      <span className=" w-full">
                        <InputText
                          id="latitude"
                          name="latitude"
                          className="w-full text-lg p-primary-input"
                          value={formik.values.latitude}
                          onChange={formik.handleChange}
                        />
                      </span>
                    </div>
                    {formik.touched?.latitude && formik.errors?.latitude && (
                      <div className="p-error">{formik.errors?.latitude}</div>
                    )}
                  </div>

                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label htmlFor="longitude" className="">
                        {t("longitude")}
                      </label>
                      <span className=" w-full">
                        <InputText
                          id="longitude"
                          name="longitude"
                          className="w-full text-lg p-primary-input"
                          value={formik.values.longitude}
                          onChange={formik.handleChange}
                        />
                      </span>
                    </div>
                    {formik.touched?.longitude && formik.errors?.longitude && (
                      <div className="p-error">{formik.errors?.longitude}</div>
                    )}
                  </div>

                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label htmlFor="address1" className="">
                        {t("address_1")}*
                      </label>
                      <span className=" w-full">
                        <InputText
                          id="address1"
                          name="address1"
                          className="w-full text-lg p-primary-input"
                          value={formik.values.address1}
                          onChange={formik.handleChange}
                        />
                      </span>
                    </div>
                    {formik.touched?.address1 && formik.errors?.address1 && (
                      <div className="p-error">{formik.errors?.address1}</div>
                    )}
                  </div>

                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label htmlFor="address2" className="">
                        {t("Address 2")}
                      </label>
                      <span className=" w-full">
                        <InputText
                          id="address2"
                          name="address2"
                          className="w-full text-lg p-primary-input"
                          value={formik.values.address2}
                          onChange={formik.handleChange}
                        />
                      </span>
                    </div>
                    {formik.touched?.address2 && formik.errors?.address2 && (
                      <div className="p-error">{formik.errors?.address2}</div>
                    )}
                  </div>

                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label htmlFor="shippingAddress1" className="">
                        {t("shipping_address_1")}*
                      </label>
                      <span className=" w-full">
                        <InputText
                          id="shippingAddress1"
                          name="shippingAddress1"
                          className="w-full text-lg p-primary-input"
                          value={formik.values.shippingAddress1}
                          onChange={formik.handleChange}
                        />
                      </span>
                    </div>
                    {formik.touched?.shippingAddress1 &&
                      formik.errors?.shippingAddress1 && (
                        <div className="p-error">
                          {formik.errors?.shippingAddress1}
                        </div>
                      )}
                  </div>

                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label htmlFor="shippingAddress2" className="">
                        {t("shipping_address_2")}
                      </label>
                      <span className=" w-full">
                        <InputText
                          id="shippingAddress2"
                          name="shippingAddress2"
                          className="w-full text-lg p-primary-input"
                          value={formik.values.shippingAddress2}
                          onChange={formik.handleChange}
                        />
                      </span>
                    </div>
                    {formik.touched?.shippingAddress2 &&
                      formik.errors?.shippingAddress2 && (
                        <div className="p-error">
                          {formik.errors?.shippingAddress2}
                        </div>
                      )}
                  </div>

                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label htmlFor="billingAddress1" className="">
                        {t("billing_address_1")}*
                      </label>
                      <span className=" w-full">
                        <InputText
                          id="billingAddress1"
                          name="billingAddress1"
                          className="w-full text-lg p-primary-input"
                          value={formik.values.billingAddress1}
                          onChange={formik.handleChange}
                        />
                      </span>
                    </div>
                    {formik.touched?.billingAddress1 &&
                      formik.errors?.billingAddress1 && (
                        <div className="p-error">
                          {formik.errors?.billingAddress1}
                        </div>
                      )}
                  </div>

                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label htmlFor="billingAddress2" className="">
                        {t("billing_address_2")}
                      </label>
                      <span className=" w-full">
                        <InputText
                          id="billingAddress2"
                          name="billingAddress2"
                          className="w-full text-lg p-primary-input"
                          value={formik.values.billingAddress2}
                          onChange={formik.handleChange}
                        />
                      </span>
                    </div>
                    {formik.touched?.billingAddress2 &&
                      formik.errors?.billingAddress2 && (
                        <div className="p-error">
                          {formik.errors?.billingAddress2}
                        </div>
                      )}
                  </div>
                </div>
              </div>
              {/* <div className="card shadow-md rounded-lg p-4 pt-1 mt-3">
                <Divider>
                  <span className="text-2xl font-bold p-font-style text-center text-primary mx-1">
                    {t("Billing Address")}
                  </span>
                </Divider>

                <div className="px-4 gap-4 grid grid-cols-1 lg:grid-cols-2">
                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label htmlFor="billing_building" className="">
                        {t("Building")}
                      </label>
                      <span className="w-full">
                        <InputText
                          id="billing_building"
                          name="billing_building"
                          className="w-full text-lg p-primary-input"
                          value={formik.values.billing_building}
                          onChange={formik.handleChange}
                        />
                      </span>
                    </div>
                    {formik.touched.billing_building &&
                      formik.errors.billing_building && (
                        <div className="p-error">
                          {formik.errors.billing_building}
                        </div>
                      )}
                  </div>

                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label
                        htmlFor="billing_building_ar"
                        className=" flex justify-end"
                      >
                        {t("رقم المبنى")}
                      </label>
                      <span className="w-full">
                        <InputText
                          id="billing_building_ar"
                          name="billing_building_ar"
                          className="w-full text-lg p-primary-input"
                          value={formik.values.billing_building_ar}
                          onChange={formik.handleChange}
                        />
                      </span>
                    </div>
                    {formik.touched.billing_building_ar &&
                      formik.errors.billing_building_ar && (
                        <div className="p-error">
                          {formik.errors.billing_building_ar}
                        </div>
                      )}
                  </div>

                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label htmlFor="billing_postalcode" className="">
                        {t("Postal Code")}
                      </label>
                      <span className="w-full">
                        <InputText
                          id="billing_postalcode"
                          name="billing_postalcode"
                          className="w-full text-lg p-primary-input"
                          value={formik.values.billing_postalcode}
                          onChange={formik.handleChange}
                        />
                      </span>
                    </div>
                    {formik.touched.billing_postalcode &&
                      formik.errors.billing_postalcode && (
                        <div className="p-error">
                          {formik.errors.billing_postalcode}
                        </div>
                      )}
                  </div>

                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label
                        htmlFor="billing_postalcode_ar"
                        className="flex justify-end"
                      >
                        {t("رمز بريدي")}
                      </label>
                      <span className="w-full">
                        <InputText
                          id="billing_postalcode_ar"
                          name="billing_postalcode_ar"
                          className="w-full text-lg p-primary-input"
                          value={formik.values.billing_postalcode_ar}
                          onChange={formik.handleChange}
                        />
                      </span>
                    </div>
                    {formik.touched.billing_postalcode_ar &&
                      formik.errors.billing_postalcode_ar && (
                        <div className="p-error">
                          {formik.errors.billing_postalcode_ar}
                        </div>
                      )}
                  </div>

                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label htmlFor="billing_country" className="">
                        {t("Country")}
                      </label>
                      <span className="w-full">
                        <InputText
                          id="billing_country"
                          name="billing_country"
                          className="w-full text-lg p-primary-input"
                          value={formik.values.billing_country}
                          onChange={formik.handleChange}
                        />
                      </span>
                    </div>
                    {formik.touched.billing_country &&
                      formik.errors.billing_country && (
                        <div className="p-error">
                          {formik.errors.billing_country}
                        </div>
                      )}
                  </div>

                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label
                        htmlFor="billing_country_ar"
                        className="flex justify-end"
                      >
                        {t("دولة")}
                      </label>
                      <span className="w-full">
                        <InputText
                          id="billing_country_ar"
                          name="billing_country_ar"
                          className="w-full text-lg p-primary-input"
                          value={formik.values.billing_country_ar}
                          onChange={formik.handleChange}
                        />
                      </span>
                    </div>
                    {formik.touched.billing_country_ar &&
                      formik.errors.billing_country_ar && (
                        <div className="p-error">
                          {formik.errors.billing_country_ar}
                        </div>
                      )}
                  </div>
                </div>
              </div>
              <div className="card shadow-md rounded-lg p-4 pt-1 mt-3">
                <Divider>
                  <span className="text-2xl font-bold p-font-style text-center text-primary mx-1">
                    {t("Billing Adress")}
                  </span>
                </Divider>

                <div className="px-4 gap-4 grid grid-cols-1 lg:grid-cols-2">
                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label htmlFor="shipping_building" className="">
                        {t("Building")}
                      </label>
                      <span className=" w-full">
                        <InputText
                          id="shipping_building"
                          name="shipping_building"
                          className="w-full text-lg p-primary-input"
                          value={formik.values.shipping_building}
                          onChange={formik.handleChange}
                        />
                      </span>
                    </div>
                    {formik.touched?.shipping_building &&
                      formik.errors?.shipping_building && (
                        <div className="p-error">
                          {formik.errors?.shipping_building}
                        </div>
                      )}
                  </div>

                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label
                        htmlFor="shipping_building_ar"
                        className="flex justify-end"
                      >
                        {t("رقم المبنى")}
                      </label>
                      <span className=" w-full">
                        <InputText
                          id="shipping_building_ar"
                          name="shipping_building_ar"
                          className="w-full text-lg p-primary-input"
                          value={formik.values.shipping_building_ar}
                          onChange={formik.handleChange}
                        />
                      </span>
                    </div>
                    {formik.touched?.shipping_building_ar &&
                      formik.errors?.shipping_building_ar && (
                        <div className="p-error">
                          {formik.errors?.shipping_building_ar}
                        </div>
                      )}
                  </div>

                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label htmlFor="shipping_postalcode" className="">
                        {t("Postal Code")}
                      </label>
                      <span className=" w-full">
                        <InputText
                          id="shipping_postalcode"
                          name="shipping_postalcode"
                          className="w-full text-lg p-primary-input"
                          value={formik.values.shipping_postalcode}
                          onChange={formik.handleChange}
                        />
                      </span>
                    </div>
                    {formik.touched?.shipping_postalcode &&
                      formik.errors?.shipping_postalcode && (
                        <div className="p-error">
                          {formik.errors?.shipping_postalcode}
                        </div>
                      )}
                  </div>

                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label
                        htmlFor="shipping_postalcode_ar"
                        className="flex justify-end"
                      >
                        {t("رمز بريدي")}
                      </label>
                      <span className=" w-full">
                        <InputText
                          id="shipping_postalcode_ar"
                          name="shipping_postalcode_ar"
                          className="w-full text-lg p-primary-input"
                          value={formik.values.shipping_postalcode_ar}
                          onChange={formik.handleChange}
                        />
                      </span>
                    </div>
                    {formik.touched?.shipping_postalcode_ar &&
                      formik.errors?.shipping_postalcode_ar && (
                        <div className="p-error">
                          {formik.errors?.shipping_postalcode_ar}
                        </div>
                      )}
                  </div>

                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label htmlFor="shipping_country" className="">
                        {t("Country")}
                      </label>
                      <span className=" w-full">
                        <InputText
                          id="shipping_country"
                          name="shipping_country"
                          className="w-full text-lg p-primary-input"
                          value={formik.values.shipping_country}
                          onChange={formik.handleChange}
                        />
                      </span>
                    </div>
                    {formik.touched?.shipping_country &&
                      formik.errors?.shipping_country && (
                        <div className="p-error">
                          {formik.errors?.shipping_country}
                        </div>
                      )}
                  </div>

                  <div className="">
                    <div className="flex flex-col gap-2">
                      <label
                        htmlFor="shipping_country_ar"
                        className="flex justify-end"
                      >
                        {t("دولة")}
                      </label>
                      <span className=" w-full">
                        <InputText
                          id="shipping_country_ar"
                          name="shipping_country_ar"
                          className="w-full text-lg p-primary-input"
                          value={formik.values.shipping_country_ar}
                          onChange={formik.handleChange}
                        />
                      </span>
                    </div>
                    {formik.touched?.shipping_country_ar &&
                      formik.errors?.shipping_country_ar && (
                        <div className="p-error">
                          {formik.errors?.shipping_country_ar}
                        </div>
                      )}
                  </div>
                </div>
              </div> */}
            </div>

            <div className="mt-8">
              <div className="flex justify-end gap-4">
                <Button
                  label={t("cancel")}
                  icon="pi pi-times"
                  className="p-red-btn"
                  type="button"
                  onClick={() => {
                    formik.resetForm();
                  }}
                />
                <Button
                  label={t("submit")}
                  icon="pi pi-check"
                  className="p-secondary-btn"
                />
              </div>
            </div>
            <MultiLanguageNames
              handleChange={formik.handleChange}
              multiNames={formik.values.multiNames}
              name={formik.values.name}
              showMultiLangModal={showMultiLangModal}
              setShowMultiLangModal={setShowMultiLangModal}
            />
          </div>
        )}
      </form>
      {activeIndex === 1 && <CustomerBalance customer={formik.values} />}
      {activeIndex === 2 && <CustomerSetup customer={formik.values} />}
    </div>
  );
}
